// user-context.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { StorageService } from './storage.service';

interface UserContext {
  name: string;
  userImage: string;
}

@Injectable({ providedIn: 'root' })
export class UserContextService {
  private userContextSubject = new BehaviorSubject<UserContext>({
    name: this.storage.getCookie('name'),
    userImage: this.storage.getCookie('userImage'),
  });

  userContext$ = this.userContextSubject.asObservable();

  constructor(private storage: StorageService) {}

  updateName(name: string) {
    this.storage.setCookie('name', name);
    this.emit();
  }

  updateProfilePicture(userImage: string) {
    this.storage.setCookie('userImage', userImage);
    this.emit();
  }

  private emit() {
    this.userContextSubject.next({
      name: this.storage.getCookie('name'),
      userImage: this.storage.getCookie('userImage'),
    });
  }
}
